// extracted by mini-css-extract-plugin
export default {"root":"YO7I0Ma0"};